<div class="bg-grey w-100" [class.search-active]="searchActive">
  <binsta-header-bar (isActive)="activateSearch($event)"></binsta-header-bar>
  <div class="canvas-holder h-100 fill-window">
    <div class="binst-window w-100 h-100">
      <canvas class="w-100 h-100" #canvas id="canvas" style="background: clear"></canvas>
      <div class="bontroller-holder">
        <binsta-bontroller></binsta-bontroller>
      </div>
      <div class="new-holder">
        <binsta-new-holder> </binsta-new-holder>
      </div>
    </div>
  </div>
</div>
